import type { DialogProps } from '@wartek-id/dialog-v1'
import { Dialog, DialogContent, DialogOverlay } from '@wartek-id/dialog-v1'

import type { FC } from 'react'

type Props = DialogProps & {
  children?: React.ReactNode
}

export const DialogRoot: FC<Props> = ({ isOpen, children, ...props }) => {
  return (
    <Dialog
      isOpen={isOpen}
      size="sm"
      type="modal"
      autoFocus={false}
      closeOnOverlayClick={false}
      {...props}
    >
      <DialogOverlay />
      <DialogContent>{children}</DialogContent>
    </Dialog>
  )
}
